import Icon, { IconProps } from '@/components/elements/Icon';

export type EditProps = IconProps;

/**
 * @component Edit
 */
function Edit({ ...rest }: EditProps) {
  return (
    <Icon viewBox="0 0 13 14" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.67792 9.38494L6.7857 4.27717C6.94608 4.11678 7.20503 4.11673 7.36475 4.27639L9.22388 6.1349C9.38201 6.29299 9.38329 6.55379 9.2232 6.7139L4.11542 11.8224C3.95504 11.9828 3.64535 12.1123 3.42306 12.1123H1.79057C1.56336 12.1123 1.38806 11.9321 1.38806 11.7098V10.0773C1.38806 9.85011 1.51784 9.54503 1.67792 9.38494ZM10.0907 2.12778L11.3734 3.40998C11.6903 3.72678 11.6925 4.24605 11.3734 4.56483L10.6086 5.32891C10.453 5.48437 10.1959 5.48239 10.0362 5.32273L8.17708 3.46422C8.01895 3.30614 8.01463 3.0484 8.17095 2.89208L8.93541 2.12762C9.25899 1.80404 9.77161 1.80875 10.0907 2.12778Z"
      />
    </Icon>
  );
}

export default Edit;
